import { Component, computed, inject, input, output, signal } from '@angular/core';
import { rxResourceFixed } from '@zayan-erp/shared';
import { DsmDealOption, DsmDealOptionProduct } from '../../../models/dsm-deal-options-view.models';
import { DsmDealOptionsService } from '../../../services/dsm-deal-options.service';
import { DsmApsAddendumOptionBasicDetailsFormComponent } from '../dsm-aps-addendum-option-basic-details-form/dsm-aps-addendum-option-basic-details-form.component';
import { AccordionModule } from '@openng/optimus-ui/accordion';
import { SkeletonModule } from '@openng/optimus-ui/skeleton';
import { FormsModule } from '@angular/forms';
import { DsmDealTaxInformationComponent } from '../dsm-deal-tax-information/dsm-deal-tax-information.component';
import { DsmDealPricingDiscountComponent } from '../dsm-deal-pricing-discount/dsm-deal-pricing-discount.component';
import { BreakpointService } from '@zayan-erp/shared';
import { toSignal } from '@angular/core/rxjs-interop';
import { DsmChangesSavedComponent } from '../dsm-changes-saved/dsm-changes-saved.component';

@Component({
  standalone: true,
  selector: 'dsm-aps-addendum-option-details',
  host: { class: 'flex flex-col h-full' },
  imports: [
    DsmApsAddendumOptionBasicDetailsFormComponent,
    AccordionModule,
    SkeletonModule,
    FormsModule,
    DsmDealTaxInformationComponent,
    DsmDealPricingDiscountComponent,
    DsmChangesSavedComponent
  ],
  templateUrl: './dsm-aps-addendum-option-details.component.html'
})
export class DsmApsAddendumOptionDetailsComponent {
  private readonly dealOptionsService = inject(DsmDealOptionsService);

  readonly dealAddendum = input.required<DsmDealOption>();
  readonly addendumProductId = input.required<string>();
  readonly isKitLinkedProduct = input<boolean>(false);

  onChanges = output<string>();
  onClose = output<void>();

  private readonly breakpointService = inject(BreakpointService);
  readonly isMobile = toSignal(this.breakpointService.isMobile$, { initialValue: false });

  productRxResource = rxResourceFixed({
    params: () => ({ addendumProductId: this.addendumProductId() }),
    defaultValue: {} as DsmDealOptionProduct,
    stream: ({ params }) => {
      return this.dealOptionsService.getAddendumOptionDetailsById(params.addendumProductId);
    }
  });

  isLoading = computed(
    () =>
      this.productRxResource.status() === 'loading' && this.productRxResource.value()?.id !== this.addendumProductId()
  );

  product = computed(() => this.productRxResource.value());

  onTaxInformationChanges() {
    this.productRxResource.reload();
    this.onChanges.emit(this.addendumProductId());
  }

  // Reload the option after a save so the form compares and rolls back against what is actually stored.
  onBasicDetailsChanges() {
    this.productRxResource.reload();
    this.onChanges.emit(this.addendumProductId());
  }
}
